module.exports = __webpack_public_path__ + "img/advantage-0.1d0bf6f3.png";